export default "__VITE_ASSET__K0FV3rI6__"